import { Skeleton, Stack } from '@mui/material';

import { useTranslation } from '../../../hooks/useTranslation';
import { AgentMetricsUnit } from '../../../interfaces/Agent';
import StyledAgentImage from '../../../styles/StyledAgentImage';
import AgentMetric from '../AgentMetric/AgentMetric';
import TextTruncated from '../TextTruncated/TextTruncated';
import StyledAgentName from '../AgentTopThree/StyledAgentName';

interface ChatAgentTopThreeProps {
  agentName: string;
  image: string;
  conversations: number;
  messages: number;
  averageSatisfaction: number;
}

const ChatAgentTopThree: React.FC<ChatAgentTopThreeProps> = ({
  agentName,
  image,
  conversations,
  messages,
  averageSatisfaction,
}) => {
  const { t } = useTranslation();

  return (
    <Stack direction="row" gap="1rem" width="400px">
      {image ? (
        <StyledAgentImage
          src={image}
          alt={t('An image of a chat agent.')}
          width="200px"
        />
      ) : (
        <Stack>
          <Skeleton
            data-testid="chat-agent-image-skeleton"
            variant="rounded"
            width="228px"
            height="228px"
          />
        </Stack>
      )}
      <Stack direction="column" gap="1rem" sx={{ width: '40%' }}>
        <StyledAgentName>
          <TextTruncated title={agentName}>{agentName}</TextTruncated>
        </StyledAgentName>
        <AgentMetric value={messages} label={t('Messages')} />
        <AgentMetric value={conversations} label={t('Conversations')} />
        <AgentMetric
          unit={AgentMetricsUnit.PERCENT}
          value={averageSatisfaction}
          label={t('Satisfaction')}
        />
      </Stack>
    </Stack>
  );
};

export default ChatAgentTopThree;
